/**
 * Return Only Number Characters
 * @param {string} value
 * @return {string}
 */
export function getOnlyNumber(value) {
  return value.replace(/\D/g, '');
}
